import { ROUTE_NAME } from '@constants';

const myPage = {
  path: '/my-page',
  redirect: '/my-page/cancellation-history',
  meta: {
    // isDesktop: true,
    breadcrumb: true,
    breadcrumbName: '마이페이지',
    navMenu: true,
    description: '회원님의 마이페이지 내역을 확인할 수 있습니다.',
  },
  children: [
    {
      name: ROUTE_NAME.CancellationHistory,
      path: 'cancellation-history',
      component: () => import('@views/mypage/CancellationHistory.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: true,
        breadcrumbName: '취소내역',
      },
    },
    {
      name: ROUTE_NAME.PenaltyHistory,
      path: 'penalty-history',
      component: () => import('@views/mypage/PenaltyHistory.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: true,
        breadcrumbName: '위약내역',
      },
    },
    {
      name: ROUTE_NAME.NewPasswordAccount,
      path: 'new-password-account',
      component: () => import('@views/mypage/NewPasswordAccount.vue'),
      meta: {
        breadcrumb: true,
        breadcrumbName: '비밀번호변경',
      },
    },
    {
      name: ROUTE_NAME.NewIDAccount,
      path: 'new-id-account',
      component: () => import('@views/mypage/NewIDAccount.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: true,
        breadcrumbName: '아이디변경',
      },
    },
  ],
};

export default myPage;
